/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateUserInHealthcareFacilityDto
 */
export interface CreateUpdateUserInHealthcareFacilityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserInHealthcareFacilityDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserInHealthcareFacilityDto
     */
    healthcareFacilityId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateUserInHealthcareFacilityDto interface.
 */
export function instanceOfCreateUpdateUserInHealthcareFacilityDto(value: object): value is CreateUpdateUserInHealthcareFacilityDto {
    return true;
}

export function CreateUpdateUserInHealthcareFacilityDtoFromJSON(json: any): CreateUpdateUserInHealthcareFacilityDto {
    return CreateUpdateUserInHealthcareFacilityDtoFromJSONTyped(json, false);
}

export function CreateUpdateUserInHealthcareFacilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateUserInHealthcareFacilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
    };
}

export function CreateUpdateUserInHealthcareFacilityDtoToJSON(value?: CreateUpdateUserInHealthcareFacilityDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'healthcareFacilityId': value['healthcareFacilityId'],
    };
}

